//
//  DateRangePicker.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import { FC } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";
import Box from "@mui/material/Box";
import { FormErrorMessage } from "./FormErrorMessage";

type DateRangePickerProps = {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  setStartDate: (date: Dayjs | null) => void;
  setEndDate: (date: Dayjs | null) => void;
  errorMsg?: string;
};

export const DateRangePicker: FC<DateRangePickerProps> = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  errorMsg,
}) => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Box display="flex" flexDirection="column" gap={1}>
      <Box display="flex" gap={2}>
        <DatePicker
          label="開始日"
          value={startDate}
          onChange={setStartDate}
          slotProps={{ textField: { size: "small" } }}
          maxDate={endDate ?? undefined}
          format="YYYY/MM/DD"
        />
        <DatePicker
          label="終了日"
          value={endDate}
          onChange={setEndDate}
          slotProps={{ textField: { size: "small" } }}
          minDate={startDate ?? undefined}
          format="YYYY/MM/DD"
        />
      </Box>
      <FormErrorMessage errorMsg={errorMsg} visible={!!errorMsg} />
    </Box>
  </LocalizationProvider>
);
